// extracted by mini-css-extract-plugin
export default {"paragraph-node-container":"ParagraphNode_paragraph-node-container__x22LL","content":"ParagraphNode_content__LibqY"};